// 引入数据配置文件
import FormConfig from "../formConfig.js";
import { fun_PostAction, fun_GetAction, fun_Download } from "@/api/index";
import { Loading } from "element-ui";
// 引入转译方法
import { fun_DownloadFile } from "@/utils/validate";
import ElectronicLicense from "../../components/electronicLicense/index.vue";
import Pictureinfor from "../../../components/pictureinfor/index.vue";
import ModifyHistoryRecord from "../../../components/modifyHistoryRecord/index.vue";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
import { watch } from "vue";

export default {
  data() {
    return {
      // 相关附件
      flieList: [
        {
          name: "中小企业划分标准路径",
          url: ""
        },
        {
          name: "企业（市场主体）管理员授权委托书",
          url: ""
        },
        {
          name: "公共资源交易事前信用承诺书",
          url: ""
        }
      ],
      // 操作标志
      controllerFlg: null,
      // 流程状态
      stepsActive: 0,
      // 流程数据
      stepsList: [
        {
          name: "基本信息",
          isSave: false, // 是否保存
          isActive: true, // 是否可点击
          icon: true, // 是否有必填项
          formList: FormConfig.basicInformation()
        },
        {
          name: "注册信息",
          isSave: false,
          isActive: true,
          icon: true, // 是否有必填项
          formList: FormConfig.registermessage()
        },
        {
          name: "安全生产许可证",
          isSave: false,
          isActive: true,
          formList: FormConfig.safetyProductionPermit()
        },
        {
          name: "联系方式",
          isSave: false,
          isActive: true,
          icon: true,
          formList: FormConfig.administratorContact()
        },
        {
          name: "外商投资",
          isSave: false,
          isActive: true,
          icon: false,
          formList: FormConfig.foreignInvestment()
        },
        {
          name: "备注及附件",
          isSave: false,
          isActive: true,
          formList: FormConfig.remark()
        },
        {
          name: "其他",
          isSave: false,
          isActive: true,
          icon: true,
          formList: FormConfig.other()
        }
      ],
      // 表单配置
      formConfigList: [],
      // 表单对象
      form: {
        // 主键
        id: null,
        // 企业名称
        corpName: null,
        // 社会信用代码
        corpCode: null,
        // 企业类型
        isSmallEnterprise: null,
        // 招投标交易主体类别
        corpRole: [],
        // 注册时间
        insertDate: null,
        // 国别/地区
        countryNum: null,
        // 注册所在省（自治区、直辖市）
        provinceNum: null,
        // 注册所在地（市、州、盟）
        cityNum: null,
        // 注册所在县（区、市、旗）
        countyNum: null,
        // 住所
        address: null,
        // 企业登记注册类型
        economicNum: null,
        // 住所邮政编码
        postalCode: null,
        // 法定代表人姓名
        legalMan: null,
        // 法定代表人性别
        legalManGender: null,
        // 法定代表人证件类型
        idCardTypeNum: null,
        // 法定代表人证件号码
        legalManIdCard: null,
        // 法定代表人职务
        legalManDuty: null,
        // 法定代表人职称
        legalManProTitle: null,
        // 经营期限
        operatingPeriod: null,
        // 法定代表人出生日期
        legalManBirthDay: null,
        // 办公电话
        officePhone: null,
        // 传真号码
        fax: null,
        // 企业网址
        url: null,
        // 注册资本
        regPrin: null,
        // 注册资本币种
        principalUnitNum: null,
        // 成立日期
        corpBirthDate: null,
        // 资信等级
        creditRate: null,
        // 经营范围
        businessScope: null,
        // 行业代码
        industryClassCode: null,
        // 证书编号
        certId: null,
        // 发证日期
        organDate: null,
        // 证书有效期截止日期
        endDate: null,
        // 联系人姓名
        linkMan: null,
        // 联系人办公电话
        linkTel: null,
        // 联系人手机号码
        linkPhone: null,
        // 联系邮箱
        email: null,
        // 备注
        description: null,
        // 变更类型
        modifyType: null,
        // 变更内容
        modifyMark: null,
        // 变更批准时间
        modifyDate: null,
        // 状态
        stateName: null,
        // 状态
        state: null
      },
      // 后台返回错误对象
      errRules: {
        // 企业名称
        corpName: null,
        // 社会信用代码
        corpCode: null,
        // 企业类型
        isSmallEnterprise: null,
        // 招投标交易主体类别
        corpRole: null,
        // 注册时间
        insertDate: null,
        // 国别/地区
        countryNum: null,
        // 注册所在省（自治区、直辖市）
        provinceNum: null,
        // 注册所在地（市、州、盟）
        cityNum: null,
        // 注册所在县（区、市、旗）
        countyNum: null,
        // 住所
        address: null,
        // 企业登记注册类型
        economicNum: null,
        // 住所邮政编码
        postalCode: null,
        // 法定代表人姓名
        legalMan: null,
        // 法定代表人性别
        legalManGender: null,
        // 法定代表人证件类型
        idCardTypeNum: null,
        // 法定代表人证件号码
        legalManIdCard: null,
        // 法定代表人职务
        legalManDuty: null,
        // 法定代表人职称
        legalManProTitle: null,
        // 经营期限
        operatingPeriod: null,
        // 法定代表人出生日期
        legalManBirthDay: null,
        // 办公电话
        officePhone: null,
        // 传真号码
        fax: null,
        // 企业网址
        url: null,
        // 注册资本币种
        principalUnitNum: null,
        // 成立日期
        corpBirthDate: null,
        // 资信等级
        creditRate: null,
        // 行业代码
        industryClassCode: null,
        // 证书编号
        certId: null,
        // 发证日期
        organDate: null,
        // 证书有效期截止日期
        endDate: null,
        // 联系人姓名
        linkMan: null,
        // 联系人办公电话
        linkTel: null,
        // 联系人手机号码
        linkPhone: null,
        // 联系邮箱
        email: null,
        // 备注
        description: null
      },
      // 表头按钮
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "circle-plus-outline"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 外商投资者类型下拉框值
      options: [
        {
          label: "境外企业",
          value: "0"
        },
        {
          label: "境外自由人",
          value: "1"
        }
      ],
      // 外商投资绑定数据
      formObj: {
        // 表格数据
        tableData: []
      },
      // 外商投资点击下标
      formObjIndex: null,
      // 勾选的数据
      multipleSelection: [],
      // 中小企业划分标准路径
      standardDivisionUrl: null,
      // 企业（市场主体）管理员授权委托书路径
      powerAttorneyUrl: null,
      // 公共资源交易事前信用承诺书路径
      letterCommitmentUrl: null,
      // 外商列表加载
      loading: false,
      // 外商列表绑定验证规则
      rules: {
        foreignCorpName: [
          {
            required: true,
            message: "请输入外商投资者名称",
            trigger: "blur"
          }
        ],
        regPrin: [
          {
            required: true,
            message: "请输入外商投入注册资金",
            trigger: "blur"
          }
        ],
        percentTage: [
          {
            required: true,
            message: "请输入外商投资所占比例",
            trigger: "blur"
          }
        ],
        foreignIvestor: [
          {
            required: true,
            message: "请选择外商投资者类型",
            trigger: "change"
          }
        ],
        principalUnitNum: [
          {
            required: true,
            message: "请选择注册资本币种",
            trigger: "change"
          }
        ],
        chineseName: [
          {
            required: true,
            message: "请选择国籍或地区",
            trigger: "blur"
          }
        ]
      },
      // 默认关闭国家或地区选择弹窗
      dialogVisible: false,
      // 国家或地区列表加载
      countryLoading: false,
      // 国家或地区查询表单绑定值
      countryForm: {
        chineseName: null, // 中文简称
        englishName: null, // 英文简称
        twoCharCode: null, // 两字符代码
        threeCharCode: null, // 单字符代码
        numberCode: null // 数字代码
      },
      // 国家或地区查询表单基础数据
      formSearchList: [
        {
          type: "input",
          label: "中文简称：",
          value: "chineseName",
          placeholder: "请输入"
        },
        {
          type: "input",
          label: "英文简称：",
          value: "englishName",
          placeholder: "请输入"
        },
        {
          type: "input",
          label: "两字符代码：",
          value: "twoCharCode",
          placeholder: "请输入"
        },
        {
          type: "input",
          label: "三字符代码：",
          value: "threeCharCode",
          placeholder: "请输入"
        },
        {
          type: "input",
          label: "数字代码：",
          value: "numberCode",
          placeholder: "请输入"
        }
      ],
      // 国家或地区表格基础数据
      tableColumns: [
        {
          label: "中文简称",
          prop: "chineseName",
          isShow: true
        },
        {
          label: "英文简称",
          prop: "englishName"
        },
        {
          label: "两字符代码",
          prop: "twoCharCode"
        },
        {
          label: "三字符代码",
          prop: "threeCharCode"
        },
        {
          label: "数字代码",
          prop: "numberCode"
        }
      ],
      // 国家或地区列表数据
      countryTableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0,
      // 核验记录条数
      auditNum: 0,
      // 交易人资质数量
      corpCertNum: 0,
      // 注册人人数
      regPersonNum: 0,
      // 交易人业绩数量
      corpAchievementNum: 0,
      // 企业奖励数量
      corpRewardsNum: 0,
      // 企业惩罚数量
      corpPunishmentNum: 0,
      // 银行基本户数量
      basicDepositAccountNum: 0,
      // 电子证照是否开启
      electronicLicenseFlag: null,
      // 是否跳转完善企业类型
      corpFlag: null,
      // 全局加载
      fullLoading: null,
      // 登录用户角色
      loginType: sessionStorage.getItem("loginType"),
      // 登录角色标识
      userFlag: sessionStorage.getItem("userFlag"),
      // 声明接收传递的值
      paramsObj: {}
    };
  },
  // 注册组件
  components: {
    ElectronicLicense, // 电子证照一览
    Pictureinfor, // 附件上传
    ModifyHistoryRecord, // 变更历史记录
    AuditHistoryRecord // 历史核验记录
  },
  // 接收父组件传递的数据
  props: {
    // 页面类型
    params: {
      type: Object,
      default: function() {
        return {}; // 正确的默认值工厂函数
      }
    }
  },
  // 监听
  watch: {
    // 监听父组件绑定值
    params: {
      // handler监听改变之后的值、改变之前的值
      handler(newName) {
        // 如果有改变的值
        if (newName) {
          // 获取最新的值
          this.paramsObj = newName;
        }
      },
      immediate: true,
      deep: false // 不需要深度监听
    }
  },
  // 模板编译完成
  mounted() {
    // 默认获取第一个流程表单
    this.formConfigList = this.stepsList[this.stepsActive].formList;
    // 获取数据
    this.paramsObj = this.params;
    // 判断是否为工作人员
    if (this.userFlag === "工作人员") {
      // 获取数据
      this.paramsObj = this.$route.query;
      // 清空当前表单
      this.formConfigList = [];
      // 遍历步骤
      this.stepsList.map(e => {
        // 获取所有表单
        this.formConfigList = [...this.formConfigList, ...e.formList];
      });
    }
    // 获取中小企业划分标准路径
    this.fun_GetFileUrl("1");
    // 获取企业（市场主体）管理员授权委托书路径
    this.fun_GetFileUrl("2");
    // 获取公共资源交易事前信用承诺书路径
    this.fun_GetFileUrl("3");
    // 获取详情
    this.fun_GetDetail();
    // 获取外商投资列表一览
    this.fun_GetCorpForeigninfoList();
    // 页面类型为查看详情
    if (this.paramsObj.type === "details") {
      // 遍历流程
      this.stepsList.map(e => {
        e.isSave = true; // 默认保存
        e.isActive = true; // 默认可点击
        // 遍历标签页
        e.formList.map(formList => {
          // 遍历标签页内表单
          formList.formConfigList.map(form => {
            // 置灰
            form.disabled = true;
          });
          // 变更记录
          if (formList.title === "变更记录") {
            // 只显示历史变更记录查看按钮
            formList.formConfigList.splice(0, 3);
          }
        });
      });
      // 隐藏外商投资列表按钮
      this.btnList = [];
    }
  },
  // 自定义方法
  methods: {
    /**
     * 获取详情
     */
    fun_GetDetail() {
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_GetAction(
        "/corpBasicinfo/detail",
        {
          id: this.paramsObj.id
        },
        0
      ).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 判断是新注册用户
          if (data.data.idCardTypeNum === "1") {
            // 新增
            this.controllerFlg = "insert";
          } else {
            // 修改
            this.controllerFlg = "update";
          }
          // 核验状态不等于通过时
          if (data.data.state !== "tg") {
            // 删除CA预约模块
            this.stepsList.map(e => {
              // 匹配步骤外商投资
              if (e.name === "外商投资" && this.controllerFlg === "insert") {
                // 遍历标签页
                e.formList.map(formList => {
                  // 遍历表单
                  formList.formConfigList.map(item => {
                    // 清空表单列表样式
                    item.class = "formList";
                  });
                });
              }
              // 匹配步骤其他
              if (e.name === "其他") {
                // 获取长度
                let index = e.formList.length;
                // 遍历
                while (index--) {
                  // 判断是新注册用户
                  if (
                    data.data.idCardTypeNum === "1" &&
                    e.formList[index].title === "变更记录"
                  ) {
                    // 删除
                    e.formList.splice(index, 1);
                  }
                  // 匹配CA预约
                  if (e.formList[index].title === "CA预约") {
                    // 删除
                    e.formList.splice(index, 1);
                  }
                }
              }
            });
          }
          // 招投标交易主体类别包含逗号
          if (data.data.corpRole && data.data.corpRole.includes(",")) {
            // 数据处理
            data.data.corpRole = data.data.corpRole.split(",");
          } else if (data.data.corpRole) {
            // 数据处理
            data.data.corpRole = data.data.corpRole.split(",");
          } else {
            // 如果为空设置空数组
            data.data.corpRole = [];
          }
          // 注册所在地（市、州、盟）
          this.fun_ChangeCityNum(data.data.provinceNum);
          // 注册所在县（区、市、旗）
          this.fun_ChangeCountyNum(data.data.cityNum);
          // 回显
          this.form = data.data;
          // 执行判断页面内容是否填写
          this.fun_GetInitializeStepsIsData();
          // 判断是新注册用户
          if (data.data.idCardTypeNum === "1") {
            // 清空证件类型
            this.form.idCardTypeNum = null;
            // 清空注册时间
            this.form.insertDate = null;
          }
          // 行业代码包含逗号
          if (
            data.data.industryClassCode &&
            data.data.industryClassCode.includes(",")
          ) {
            // 数据处理
            this.form.industryClassCode = data.data.industryClassCode.split(
              ","
            );
          }
          // 交易人资质数量
          this.corpCertNum = data.corpCertNum;
          // 注册人人数
          this.regPersonNum = data.regPersonNum;
          // 交易人业绩数量
          this.corpAchievementNum = data.corpAchievementNum;
          // 企业奖励数量
          this.corpRewardsNum = data.corpRewardsNum;
          // 企业惩罚数量
          this.corpPunishmentNum = data.corpPunishmentNum;
          // 银行基本户数量
          this.basicDepositAccountNum = data.basicDepositAccountNum;
          // 核验记录条数
          this.auditNum = data.auditNum;
          // 电子证照是否开启
          this.electronicLicenseFlag = data.electronicLicenseFlag;
          // 是否跳转完善企业类型
          this.corpFlag = data.corpFlag;
          // 原核验次数
          if (this.auditNum === "0") {
            // 遍历流程
            this.stepsList.map(e => {
              // 遍历标签页
              e.formList.map(formList => {
                // 变更记录
                if (formList.title === "变更记录") {
                  // 只显示历史变更记录查看按钮
                  formList.formConfigList.splice(0, 3);
                }
              });
            });
          }
          // 关闭遮罩
          this.fullLoading.close();
        } else {
          // 关闭遮罩
          this.fullLoading.close();
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },

    /**
     * 多选框勾选事件
     * @author shuhua
     */
    fun_GetCheckboxVal(e) {
      // 赋值
      this.form.corpRole = e;
    },

    /**
     * 监听滚动
     */
    fun_HandleScroll(e) {
      // 判断
      if (e.target.offsetTop < this.$refs.sticky.offsetTop + 140) {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "0 0 8px 3px rgba(0, 0, 0, 0.06)";
      } else {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "none";
      }
    },
    /**
     * 获取文件模板路径
     * @author shuhua
     */
    fun_GetFileUrl(e) {
      // 下载的文件名称
      let appName = null;
      // 中小企业划分标准
      if (e === "1") {
        appName = "中小企业划型标准规定";
        // 企业（市场主体）管理员授权委托书
      } else if (e === "2") {
        appName = "企业（市场主体）管理员授权委托书";
        // 公共资源交易事前信用承诺书
      } else {
        appName = "公共资源交易事前信用承诺书";
      }
      // 发起请求
      fun_GetAction("/clientFileInfo/getAutomaticallyUpdateFiles", {
        number: 2,
        appName: appName
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 中小企业划分标准
          if (e === "1") {
            // 中小企业划分标准路径
            this.standardDivisionUrl = data;
            this.flieList[0].url = data;
          } else if (e === "2") {
            // 企业（市场主体）管理员授权委托书路径
            this.powerAttorneyUrl = data;
            this.flieList[1].url = data;
          } else {
            // 公共资源交易事前信用承诺书路径
            this.letterCommitmentUrl = data;
            this.flieList[2].url = data;
          }
        }
      });
    },
    /**
     * 文件下载
     */
    fun_Download(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },
    /**
     * 获取外商投资列表一览
     * @author shuhua
     */
    fun_GetCorpForeigninfoList() {
      // 发起请求
      fun_PostAction("/corpForeigninfo/list", {
        basicInfoId: this.paramsObj.id
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 赋值
          this.formObj.tableData = data;
          // 遍历流程数据
          this.stepsList.map((item, index) => {
            // 判断是外商投资
            if (item.name === "外商投资") {
              // 判断是否存在数据
              if (this.formObj.tableData.length > 0) {
                // 改变状态
                item.isSave = true;
              }
            }
          });
        } else {
          // 操作失败提示信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 调用添加方法
          var newValue = {
            foreignCorpName: null,
            regPrin: null,
            percentTage: null,
            foreignIvestor: null,
            principalUnitNum: null,
            chineseName: null,
            nationNum: null
          };
          //添加新的行数
          this.formObj.tableData.push(newValue);
          break;
        default:
          // 判断是否勾选
          if (this.multipleSelection.length <= 0) {
            // 提示信息
            this.$alert("最少选择一条数据！", "warning");
            return;
          }
          // 弹出询问confirm
          this.$confirm("是否确定删除选中数据?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 遍历
            this.multipleSelection.map((value, index) => {
              // 遍历
              this.formObj.tableData.map((v, i) => {
                // 匹配已选中的
                if (value.index === v.index) {
                  // 删除勾选的数据
                  this.formObj.tableData.splice(i, 1);
                }
              });
            });
            // 清除选中数据
            this.$refs.multipleTable.clearSelection();
          });
      }
    },
    /**
     * 列表添加class
     */
    addClass(row, column, rowIndex, columnIndex) {
      // 判断是序号
      if (row.column.type === "index") {
        return "index";
      }
    },
    /**
     * 添加时执行的方法
     * @author shuhua
     */
    tableRowClassName(row, rowIndex) {
      // 给每一行新增一个下标
      row.row.index = row.rowIndex;
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 注册所在省（自治区、直辖市）
      if (i === "provinceNum") {
        // 赋值
        this.form.provinceNum = e;
        // 注册所在地（市、州、盟）
        this.fun_ChangeCityNum(e);
        // 清空注册所在地（市、州、盟）
        this.form.cityNum = null;
        // 清空注册所在县（区、市、旗）
        this.form.countyNum = null;
      }
      // 注册所在地（市、州、盟）
      else if (i === "cityNum") {
        // 赋值
        this.form.cityNum = e;
        // 注册所在县（区、市、旗）
        this.fun_ChangeCountyNum(e);
        // 清空注册所在县（区、市、旗）
        this.form.countyNum = null;
      }
      // 行业代码
      else if (i === "industryClassCode") {
        // 赋值
        this.form.industryClassCode = e[1];
      } else {
        // 其他字段
        // 赋值
        this.form[i] = e;
      }
    },
    /**
     * 企业类型下拉框值改变事件
     * @author shuhua
     */
    fun_ChangeCorpType(e) {
      // 赋值
      this.form.isSmallEnterprise = e.code;
    },
    /**
     * 注册所在地（ 市、 州、 盟）
     */
    fun_ChangeCityNum(val) {
      // 遍历流程
      this.stepsList.map(e => {
        // 遍历标签页
        e.formList.map(formList => {
          // 遍历表单
          formList.formConfigList.map(item => {
            // 所在地
            if (item.value === "cityNum") {
              // 修改下拉框请求参数，重新赋值
              item.queryParams = {
                url: "/administrativeArea/administrativeAreaList",
                parentAreaCode: val,
                levelNum: "201507041523190005"
              };
            }
          });
        });
      });
    },
    /**
     * 注册所在县（区、市、旗）下拉框值改变事件
     * @author shuhua
     */
    fun_ChangeCountyNum(val) {
      // 遍历流程
      this.stepsList.map(e => {
        // 遍历标签页
        e.formList.map(formList => {
          // 遍历表单
          formList.formConfigList.map(item => {
            // 所在县
            if (item.value === "countyNum") {
              // 修改下拉框请求参数，重新赋值
              item.queryParams = {
                url: "/administrativeArea/administrativeAreaList",
                parentAreaCode: val,
                levelNum: "201507041524020006"
              };
            }
          });
        });
      });
    },
    /**
     * 外商投资注册资本币种下拉框值改变事件
     * @author shuhua
     */
    fun_ChangeUnitNum(e, i) {
      // 赋值
      this.formObj.tableData[i].principalUnitNum = e;
    },
    /**
     * 打开弹窗查询国家和地区的弹窗
     */
    fun_OpenCountry(index) {
      // 存储点击的下标
      this.formObjIndex = index;
      // 打开弹窗
      this.dialogVisible = true;
      // 获取国家或地区一览数据
      this.fun_GetNationalList();
    },
    /**
     * 获取国家或地区一览数据
     * @author shuhua
     */
    fun_GetNationalList() {
      // 发起请求
      fun_PostAction("/nationalNameCode/list", {
        ...this.countryForm,
        ...this.reqPageData
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 国家或地区表格数据
          this.countryTableData = data.records;
          // 国家或地区列表总条数
          this.total = data.total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 国家或地区列表查询事件
     * @author shuhua
     */
    fun_Search() {
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetNationalList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetNationalList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetNationalList();
    },
    /**
     * 国家地域选择返回值
     * @author shuhua
     */
    fun_SetNationalNameCode(e) {
      // 赋值
      this.formObj.tableData[this.formObjIndex].chineseName = e.val.chineseName;
      // 赋值
      this.formObj.tableData[this.formObjIndex].nationNum = e.val.numberCode;
      // 关闭弹窗
      this.dialogVisible = false;
    },
    /**
     * 外商投资列表勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 赋值勾选数组
      this.multipleSelection = e;
    },
    /**
     * 打开电子证照一览
     */
    fun_OpenElctronicLicense() {
      // 询问框
      this.$confirm("是否获取企业相关证照？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 组织机构代码为空
        if (!this.form.corpCode) {
          // 错误消息提示
          this.$alert("请填写社会信用代码！", "提示", { type: "warning" });
          return false;
        }
        // 企业名称为空
        if (!this.form.corpName) {
          // 错误消息提示
          this.$alert("请填写企业名称！", "提示", { type: "warning" });
          return false;
        }
        // 打开弹窗
        this.$refs.electronicLicense.dialogVisible = true;
        // 打开弹框时调用
        this.$refs.electronicLicense.fun_GetList();
      });
    },
    /**
     * 打开上传附件弹窗
     * @author shuhua
     */
    fun_OpenUpload() {
      // 打开弹窗
      this.$refs.pictureinfor.dialogVisible = true;
      // 打开弹框时调用
      this.$refs.pictureinfor.fun_GetOpen();
    },
    /**
     * 打开变更历史记录弹窗
     */
    fun_OpenModifyHistoryRecord() {
      // 打开弹窗
      this.$refs.modifyHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.modifyHistoryRecord.fun_GetList();
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 递归验证所有必填项
     */
    fun_GetFormValidate(index, e) {
      // 验证表单
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 设置状态用于前端显示效果
          this.stepsList[index].isSave = true;
          // 判断当前下标是否为最长
          if (index === this.stepsList.length - 1) {
            // 询问框
            this.$confirm(
              "您是否已经阅读免责声明，确认提交吗？提交后您的信息将会直接通过！用户须确认在市公共资源交易主体数据库填报的所有信息，均合法、真实、准确、有效，无任何伪造、修改、虚假成份，并对所提供信息的真实性负责。",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }
            ).then(() => {
              // 提交
              this.fun_SaveOrUpdate(e);
            });
          } else {
            // 判断当前流程是否为外商投资
            if (this.stepsList[index].name === "外商投资") {
              // 外商投资列表验证
              this.$refs.ruleForm.validate(listValid => {
                // 验证通过
                if (valid && listValid) {
                  // 获取表单数据
                  this.formConfigList = this.stepsList[index + 1].formList;
                  // 再次递归验证表单
                  this.$nextTick(() => {
                    return this.fun_GetFormValidate(index + 1, e);
                  });
                } else {
                  // 错误提示
                  this.$alert(
                    "输入内容存在错误，请根据提示完善内容！",
                    "warning"
                  );
                  // 验证不通过
                  return false;
                }
              });
            } else {
              // 获取表单数据
              this.formConfigList = this.stepsList[index + 1].formList;
              // 再次递归验证表单
              this.$nextTick(() => {
                return this.fun_GetFormValidate(index + 1, e);
              });
            }
          }
        } else {
          // 显示当前流程
          this.stepsActive = index;
        }
      });
    },
    /**
     * 提交的方法
     * @author shuhua
     */
    fun_Submit(e) {
      // 判断为保存
      if (e === "bc") {
        // 保存
        this.fun_SaveOrUpdate(e);
        return;
      }
      // 声明
      var flag = true;
      // 遍历流程
      this.stepsList.map((item, index) => {
        // 判断
        if (flag && !this.stepsList.length === index + 1) {
          // 判断流程
          if (!item.isSave) {
            // 修改状态
            flag = false;
          }
        }
      });
      // 判断
      if (!flag) {
        // 提示
        this.$alert("存在未保存数据，请根据流程进行提交保存操作！", "warning");
        return false;
      }
      // 截止时间小于发证时间时
      if (
        new Date(this.form.endDate).getTime() <
        new Date(this.form.organDate).getTime()
      ) {
        // 错误提示
        this.$alert("截止时间应晚于发证时间！", "warning");
        // 验证不通过
        return false;
      }
      // 验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 判断验证
        if (valid) {
          // 判断当前流程是否为外商投资
          if (this.stepsList[this.stepsActive].name === "外商投资") {
            // 外商投资列表验证
            this.$refs.ruleForm.validate(listValid => {
              // 验证通过
              if (valid && listValid) {
                // 设置状态用于前端显示效果
                this.stepsList[this.stepsActive].isSave = true;
                // 递归验证表单
                this.fun_GetFormValidate(0, e);
              } else {
                // 错误提示
                this.$alert(
                  "输入内容存在错误，请根据提示完善内容！",
                  "warning"
                );
                // 验证不通过
                return false;
              }
            });
          } else {
            // 设置状态用于前端显示效果
            // this.stepsList[this.stepsActive].isSave = true;
            // 获取表单数据
            this.formConfigList = this.stepsList[0].formList;
            // 递归验证表单
            this.fun_GetFormValidate(0, e);
          }
        } else {
          // 错误提示
          this.$alert("输入内容存在错误，请根据提示完善内容！", "warning");
          // 验证不通过
          return false;
        }
      });
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(e) {
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("/corpBasicinfo/saveOrUpdate", {
        ...this.form,
        state: e,
        list: JSON.stringify(this.formObj.tableData),
        auditNum: this.auditNum,
        controllerFlg: this.controllerFlg
      })
        .then(res => {
          // 加载框取消
          this.fullLoading.close();
          // 解构res.data
          const { result, data, msg } = res.data;
          // 操作成功
          if (result) {
            // 返回消息不为空
            if (data.msg) {
              // 消息提示
              this.$alert(data.msg, "info");
            } else {
              if (e !== "bc") {
                // 返回错误消息
                this.$message.success(msg);
              }
            }
            // 判断是保存
            if (e === "bc") {
              // 修改状态
              this.controllerFlg = "update";
              // 获取中小企业划分标准路径
              this.fun_GetFileUrl("1");
              // 获取企业（市场主体）管理员授权委托书路径
              this.fun_GetFileUrl("2");
              // 获取公共资源交易事前信用承诺书路径
              this.fun_GetFileUrl("3");
              // 获取详情
              this.fun_GetDetail();
              // 获取外商投资列表一览
              this.fun_GetCorpForeigninfoList();
            }
          } else {
            if (data != null) {
              // 定义rules为一个随机数
              this.errRules = Math.random();
              // 执行延迟方法
              this.$nextTick(() => {
                // 如果文件提示不为空
                if (data.file) {
                  // 提示
                  this.$message.error(data.file);
                } else {
                  // 提示
                  this.$message.error("请按提示修改");
                }
                // 赋值错误消息
                this.errRules = res.data.data;
              });
              // 跳转页面
              this.fun_SetStepsActive(data);
            } else {
              // 返回错误消息
              this.$message.error(msg);
            }
          }
        })
        .catch(() => {
          // 加载框取消
          this.fullLoading.close();
        });
    },
    /**
     * 跳转页面
     */
    fun_SetStepsActive(data) {
      // 返回不为空
      if (data != null) {
        // 如果是社会信用代码或者出生日期
        if (data.corpCode || data.legalManBirthDay) {
          // 显示当前流程
          this.stepsActive = 0;
        }
        // 如果是成立日期
        else if (data.corpBirthDate) {
          // 显示当前流程
          this.stepsActive = 1;
        }
        // 如果是证书有效期截止时间
        else if (data.endDate) {
          // 显示当前流程
          this.stepsActive = 2;
        }
        // 如果是文件
        else if (data.file) {
          // 显示当前流程
          this.stepsActive = 5;
        }
        // 获取表单数据
        this.formConfigList = this.stepsList[this.stepsActive].formList;
      }
    },
    /**
     * 全局加载
     * @author liutong
     */
    fun_Loading(val) {
      this.fullLoading = this.$loading({
        lock: true,
        text: val ? val : "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 初始化时处理流程判断表单是否填写内容
     */
    fun_GetInitializeStepsIsData() {
      // 遍历流程数据
      this.stepsList.map((item, index) => {
        // 判断是外商投资
        if (item.name === "外商投资") {
          // 判断是否存在数据
          if (this.formObj.tableData.length > 0) {
            // 改变状态
            item.isSave = true;
          }
        }
        // 遍历表单内容
        item.formList.map(formList => {
          // 遍历表单字段
          formList.formConfigList.map(form => {
            // 判断是否填写内容
            if (this.form[form.value]) {
              // 改变状态
              item.isSave = true;
            } else {
              // 赋值下标
              // this.stepsActive = index;
              // 获取表单数据
              // this.formConfigList = item.formList;
            }
          });
        });
      });
    },
    /**
     * 用于判断当前流程是否填写数据
     */
    fun_GetStepsIsData() {
      // 声明
      var formArr = []; // 所有表单
      var isFormKey = false; // 是否填写
      // 遍历获取所有表单数据
      this.formConfigList.map(item => {
        // 判断是否存在表单
        if (item.formConfigList && item.formConfigList.length > 0)
          formArr.push(...item.formConfigList);
      });
      // 判断是外商投资
      if (this.stepsList[this.stepsActive].name === "外商投资") {
        // 判断是否存在数据
        if (this.formObj.tableData.length > 0) {
          // 改变标识
          isFormKey = true;
        } else {
          // 改变标识
          isFormKey = false;
        }
      } else {
        // 判断当前表单
        for (var i = 0; i < formArr.length; i++) {
          // 判断字段是否填写值
          if (this.form[formArr[i].value]) {
            // 改变标识
            isFormKey = true;
            // 跳出循环
            break;
          }
        }
      }
      return isFormKey;
    },
    /**
     * 点击流程
     */
    fun_GetClickSteps(val, index) {
      // 判断是否填写内容
      if (this.fun_GetStepsIsData()) {
        // 修改状态用于前端显示
        this.stepsList[this.stepsActive].isSave = true;
      } else {
        // 修改状态用于前端显示
        this.stepsList[this.stepsActive].isSave = false;
      }
      // 判断状态不是通过
      if (this.form.state != "tg") this.fun_Submit("bc");
      // 赋值下标
      this.stepsActive = index;
      // 获取表单数据
      this.formConfigList = val.formList;
    },
    /**
     * 上一步
     */
    fun_GetLastStep() {
      // 判断当前流程为0
      if (this.stepsActive === 0) return;
      // 判断是否填写内容
      if (this.fun_GetStepsIsData()) {
        // 修改状态用于前端显示
        this.stepsList[this.stepsActive].isSave = true;
      } else {
        // 修改状态用于前端显示
        this.stepsList[this.stepsActive].isSave = false;
      }
      // 判断状态不是通过
      if (this.form.state != "tg") this.fun_Submit("bc");
      // 减1
      this.stepsActive--;
      // 获取表单数据
      this.formConfigList = this.stepsList[this.stepsActive].formList;
    },
    /**
     * 下一步
     */
    fun_GetNextStep() {
      // 判断当前流程走到最后
      if (this.stepsList.length - 1 === this.stepsActive) return;
      // 判断是否填写内容
      if (this.fun_GetStepsIsData()) {
        // 修改状态用于前端显示
        this.stepsList[this.stepsActive].isSave = true;
      } else {
        // 修改状态用于前端显示
        this.stepsList[this.stepsActive].isSave = false;
      }
      // 判断当前不是详情
      if (this.form.state != "tg") this.fun_Submit("bc");
      // 赋值下标
      this.stepsActive++;
      // 获取表单数据
      this.formConfigList = this.stepsList[this.stepsActive].formList;
    },
    /**
     * 其他信息按钮
     */
    fun_OtherClick(e) {
      switch (e) {
        case "企业资质":
          this.$emit("fun_Back", "201508051011590003");
          break;
        case "交易主体业绩":
          this.$emit("fun_Back", "201508051013120005");
          break;
        case "交易主体奖励":
          this.$emit("fun_Back", "201508051013580006");
          break;
        case "交易主体惩罚":
          this.$emit("fun_Back", "201806261709050170");
          break;
        case "项目负责人":
          this.$emit("fun_Back", "201508051012370004");
          break;
        case "银行基本户":
          this.$emit("fun_Back", "201508211730580003");
          break;
        default:
      }
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 判断是工作人员
      if (this.userFlag === "工作人员" || this.userFlag === "注册用户") {
        // 返回
        this.$router.back();
        return false;
      }
      // 返回
      this.$emit("fun_Back");
    }
  }
};
